import { render, staticRenderFns } from "./PeopleList.vue?vue&type=template&id=c60d435c&scoped=true"
import script from "./PeopleList.vue?vue&type=script&lang=js"
export * from "./PeopleList.vue?vue&type=script&lang=js"
import style0 from "./PeopleList.vue?vue&type=style&index=0&id=c60d435c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60d435c",
  null
  
)

export default component.exports